// extracted by mini-css-extract-plugin
export default {"root":"CoursewareInfo_root__B61-C"};